import { render, staticRenderFns } from "./BSelect.vue?vue&type=template&id=416f8208&scoped=true"
import script from "./BSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./BSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BSelect.vue?vue&type=style&index=0&id=416f8208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f8208",
  null
  
)

export default component.exports